import {
  qlSyncScreeningQuotas,
  updateState,
} from 'containers/QuestionnaireLogic/utils';
import findQuestionByRefId from 'utils/findQuestionByRefId';

import {
  itemKey,
  qlSetScreenerTypes,
  qlSetScreeningStartingShape,
} from '../screening';
import { validateQuotaAndUpdateState } from '../utils';
import { saveCheckpointHandler } from '../reducer_utils';

// Applies `qlUpdate` to a screening node's rules, then keeps its quotas in
// step: a quota goes with an item leaving allowed, and an item returning to
// allowed gets a new one at 0.
function updateScreeningRules(state, questionRefId, qlUpdate) {
  const node = findQuestionByRefId(
    state.surveyDetailsExtended.questions,
    questionRefId,
  );
  if (!node?.isScreening) return state;

  const previousQl = state.questionnaireLogic.ql;
  const ql = qlSyncScreeningQuotas({
    state,
    node,
    ql: qlUpdate({ node, ql: previousQl }),
    previousQl,
  });

  const updatedState = Object.assign({}, saveCheckpointHandler(state, true), {
    questionnaireLogic: updateState({
      ql,
      questionnaireLogic: state.questionnaireLogic,
    }),
    surveyDetailsExtended: {
      ...state.surveyDetailsExtended,
      questionnaireEditVersion:
        state.surveyDetailsExtended.questionnaireEditVersion + 1,
    },
  });

  return validateQuotaAndUpdateState(updatedState, questionRefId);
}

// SET_ANSWER_SCREENER_TYPE
export function setAnswerScreenerTypeHandler(state, action) {
  const { questionRefId, answerRefId, columnRefId, screenerType } =
    action.payload;

  return updateScreeningRules(state, questionRefId, ({ node, ql }) =>
    qlSetScreenerTypes({
      node,
      ql,
      screenerTypes: {
        [itemKey({ answerRefId, columnRefId })]: screenerType,
      },
    }),
  );
}

// RESET_SCREENER_TYPES
export function resetScreenerTypesHandler(state, action) {
  const { questionRefId } = action.payload;

  return updateScreeningRules(
    state,
    questionRefId,
    qlSetScreeningStartingShape,
  );
}
